import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ResidenceSection } from '../ResidenceSection';
import { infrastructureSectionStyles } from './styled';

const InfrastructureSection = memo(infrastructures => {
  const { t } = useTranslation();

  return (
    <ResidenceSection styles={infrastructureSectionStyles}>
      <div className="infrastructure-container">
        <div className="infrastructure">
          <div className="infrastructure__title">
            {t('residences.infrastructure')}
          </div>
          <div className="infrastructure-i">
            {infrastructures &&
              infrastructures?.infrastructures.map((item, index) => {
                return (
                  <div className="infrastructure-i__item" key={index}>
                    <img src={item.infrastructure.iconUrl} alt="" />
                    <div className="infrastructure-i__item__title">
                      {item.infrastructure.name}
                    </div>
                    <div className="infrastructure-i__item__description">
                      {t('residences.minutes', { minutes: item.distance })}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </ResidenceSection>
  );
});

InfrastructureSection.displayName = `InfrastructureSection`;

InfrastructureSection.propTypes = {
  priceMin: PropTypes.number,
  priceMax: PropTypes.number,
  currency: PropTypes.string,
  deadline: PropTypes.string
};

export default InfrastructureSection;
